import Vue from 'vue'
import { api } from '@/services/api'

export class AssessmentService {
    async setReviewed(assessmentId) {
        const url = `web.assessment/${assessmentId}/nc_reviewed_email/`
        try {
            const resp = await Vue.axios.post(url)
            const { status, data } = resp
            return { status, data }
        } catch (e) {
            const { response } = e
            return {
                status: response?.status,
                data: response?.data
            }
        }
    }

    /**
     * §H.2.4a — fetch the full assessment detail (replaces
     * getAssessment.gql). Returns the deeply nested shape the
     * Apollo block produced, deep-camelcased by api.js so
     * callers read `accreditation.surveyVersion.editionNumber`
     * and the flat `responsesAggregate.{mets, riskMajor, ...}`.
     */
    async fetchAssessmentData(assessmentId) {
        return api.get(`web.assessment/${assessmentId}/full_detail/`)
    }

    /**
     * §H.2.4b — fetch the per-IndicatorResponse list (replaces
     * getIndicatorsResponse.gql). Returns
     * `{ id, submissions, generalComments, responses,
     * surveyVisit{ accreditation{ selfAssessment{ responses } } } }`
     * after api.js's deep camelcase.
     */
    async fetchIndicatorResponses(assessmentId) {
        return api.get(`web.assessment/${assessmentId}/indicators_response/`)
    }

    /**
     * §H.3.1 — single-row PATCH replacing
     * update_indicator_response_by_pk. Caller passes camelCase
     * fields; api.js snake_cases the request body and camelcases
     * the response.
     */
    async updateIndicatorResponse(responseId, payload) {
        return api.patch(`web.indicatorresponse/${responseId}/`, payload)
    }

    /**
     * §H.3.1 — bulk PATCH replacing the Hasura
     * insert_indicator_response upsert. Body is a list of
     * `{id, ...fields}`; BE updates each row in a transaction so
     * partial failures abort. Returns the camelcased list of
     * updated rows.
     */
    async upsertIndicatorResponses(responses) {
        return api.patch('web.indicatorresponse/bulk/', responses)
    }

    /**
     * §H.3.2 — single-row PATCH replacing
     * update_comment_by_pk. The Hasura mutation only updated
     * the `comment` text field; this service surface keeps that
     * narrow so the BE doesn't have to accept the wider
     * CommentSerializer write shape from this caller.
     */
    async updateComment(commentId, payload) {
        return api.patch(`web.comment/${commentId}/`, payload)
    }
}

export const assessmentService = new AssessmentService()
